import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Animation, Camera, Cursor, DaydreamControls, GearvrControls, GenericTrackedControllerControls, Geometry, GLTFModel, HandControls, HandTrackingControls, HpMixedRealityControls, LaserControls, Layer, Light, Line, Link, LookControls, MagicleapControls, Material, ObjModel, OculusGoControls, OculusTouchControls, Position, Raycaster, Rotation, Scale, Shadow, Sound, Text, TrackedControlsWebVR, TrackedControlsWebXR, TrackedControls, ValveIndexControls, Visible, ViveControls, ViveFocusControls, WASDControls, WindowsMotionControls } from '../components';
import parse from '../utils/propParser';
export function toProps(props, removalKeys) {
  var defaultKeys = ['id', 'className', 'children', 'animation', 'camera', 'cursor', 'daydreamControls', 'gearvrControls', 'genericTrackedControllerControls', 'geometry', 'gltfModel', 'handControls', 'handTrackingControls', 'hpMixedRealityControls', 'laserControls', 'layer', 'light', 'line', 'link', 'lookControls', 'magicleapControls', 'material', 'objModel', 'oculusGoControls', 'oculusTouchControls', 'position', 'raycaster', 'rotation', 'scale', 'shadow', 'sound', 'text', 'trackedControlsWebVR', 'trackedControlsWebXR', 'trackedControls', 'valveIndexControls', 'visible', 'viveControls', 'viveFocusControls', 'wasdControls', 'windowsMotionControls'];
  var animationKeys = Object.keys(props).filter(function (key) {
    return key.includes('animation__');
  });
  var animationProps = animationKeys.reduce(function (acc, key) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[key] = new Animation(props[key]).toString(), _extends2));
  }, {});
  var extraKeys = Object.keys(props).filter(function (key) {
    return !defaultKeys.includes(key) && !key.includes('animation__');
  });
  var extraProps = (removalKeys ? extraKeys.filter(function (key) {
    return !removalKeys.includes(key);
  }) : extraKeys).reduce(function (acc, key) {
    var _extends3;

    return _extends({}, acc, (_extends3 = {}, _extends3[key] = parse(props[key]), _extends3));
  }, {});
  var id = props.id,
      className = props.className,
      animation = props.animation,
      camera = props.camera,
      cursor = props.cursor,
      daydreamControls = props.daydreamControls,
      gearvrControls = props.gearvrControls,
      genericTrackedControllerControls = props.genericTrackedControllerControls,
      geometry = props.geometry,
      gltfModel = props.gltfModel,
      handControls = props.handControls,
      handTrackingControls = props.handTrackingControls,
      hpMixedRealityControls = props.hpMixedRealityControls,
      laserControls = props.laserControls,
      layer = props.layer,
      light = props.light,
      line = props.line,
      link = props.link,
      lookControls = props.lookControls,
      magicleapControls = props.magicleapControls,
      material = props.material,
      objModel = props.objModel,
      oculusGoControls = props.oculusGoControls,
      oculusTouchControls = props.oculusTouchControls,
      position = props.position,
      raycaster = props.raycaster,
      rotation = props.rotation,
      scale = props.scale,
      shadow = props.shadow,
      sound = props.sound,
      text = props.text,
      trackedControlsWebVR = props.trackedControlsWebVR,
      trackedControlsWebXR = props.trackedControlsWebXR,
      trackedControls = props.trackedControls,
      valveIndexControls = props.valveIndexControls,
      visible = props.visible,
      viveControls = props.viveControls,
      viveFocusControls = props.viveFocusControls,
      wasdControls = props.wasdControls,
      windowsMotionControls = props.windowsMotionControls;
  return _extends({
    id: id,
    "class": className,
    animation: animation && new Animation(animation).toString(),
    camera: camera && new Camera(camera).toString(),
    cursor: cursor && new Cursor(cursor).toString(),
    'daydream-controls': daydreamControls && new DaydreamControls(daydreamControls).toString(),
    'gearvr-controls': gearvrControls && new GearvrControls(gearvrControls).toString(),
    'generic-tracked-controller-controls': genericTrackedControllerControls && new GenericTrackedControllerControls(genericTrackedControllerControls).toString(),
    geometry: geometry && new Geometry(geometry).toString(),
    'gltf-model': gltfModel && new GLTFModel(gltfModel).toString(),
    'hand-controls': handControls && new HandControls(handControls).toString(),
    'hand-tracking-controls': handTrackingControls && new HandTrackingControls(handTrackingControls).toString(),
    'hp-mixed-reality-controls': hpMixedRealityControls && new HpMixedRealityControls(hpMixedRealityControls).toString(),
    'laser-controls': laserControls && new LaserControls(laserControls).toString(),
    layer: layer && new Layer(layer).toString(),
    light: light && new Light(light).toString(),
    line: line && new Line(line).toString(),
    link: link && new Link(link).toString(),
    'look-controls': lookControls && new LookControls(lookControls).toString(),
    'magicleap-controls': magicleapControls && new MagicleapControls(magicleapControls).toString(),
    material: material && new Material(material).toString(),
    'obj-model': objModel && new ObjModel(objModel).toString(),
    'oculus-go-controls': oculusGoControls && new OculusGoControls(oculusGoControls).toString(),
    'oculus-touch-controls': oculusTouchControls && new OculusTouchControls(oculusTouchControls).toString(),
    position: position && new Position(position).toString(),
    raycaster: raycaster && new Raycaster(raycaster).toString(),
    rotation: rotation && new Rotation(rotation).toString(),
    scale: scale && new Scale(scale).toString(),
    shadow: shadow && new Shadow(shadow).toString(),
    sound: sound && new Sound(sound).toString(),
    text: text && new Text(text).toString(),
    'tracked-controls-webvr': trackedControlsWebVR && new TrackedControlsWebVR(trackedControlsWebVR).toString(),
    'tracked-controls-webxr': trackedControlsWebXR && new TrackedControlsWebXR(trackedControlsWebXR).toString(),
    'tracked-controls': trackedControls && new TrackedControls(trackedControls).toString(),
    'valve-index-controls': valveIndexControls && new ValveIndexControls(valveIndexControls).toString(),
    visible: visible !== undefined ? new Visible(visible).toString() : undefined,
    'vive-controls': viveControls && new ViveControls(viveControls).toString(),
    'vive-focus-controls': viveFocusControls && new ViveFocusControls(viveFocusControls).toString(),
    'wasd-controls': wasdControls && new WASDControls(wasdControls).toString(),
    'windows-motion-controls': windowsMotionControls && new WindowsMotionControls(windowsMotionControls).toString()
  }, animationProps, extraProps);
}
/**
 * A-Frame represents an entity via the `<a-entity>` element. As defined in the [entity-component-system pattern](https://aframe.io/docs/1.3.0/introduction/entity-component-system.html),
 * entities are placeholder objects to which we plug in components to provide them
 * appearance, behavior, and functionality.
 *
 * In A-Frame, entities are inherently attached with the
 * [position](https://aframe.io/docs/1.3.0/components/position.html),
 * [rotation](https://aframe.io/docs/1.3.0/components/rotation.html), and
 * [scale](https://aframe.io/docs/1.3.0/components/scale.html) components.
 *
 * @see https://aframe.io/docs/1.3.0/core/entity.html
 */

export default function Entity(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("a-entity", toProps(props), children);
}